import {Answer} from "@/entities/questionaire/answers/Answer";
import { Treatment } from "./Treatment";

export class SelfcheckReport {
    branchId: number;
    useOnlyMyOpinion: boolean;
    answers: Answer[];
    treatmentHistory: Treatment[] | null;
    excludedRecommendations: {
        id: number;
        name: string;
        approvalPercentage: number;
    }[];
    comment: string;

    constructor(
        branchId: number, 
        useOnlyMyOpinion: boolean, 
        answers: Answer[], 
        treatmentHistory: Treatment[] | null,
        excludedRecommendations: {
            id: number;
            name: string;
            approvalPercentage: number;
        }[], 
        comment: string,
    ) {
        this.branchId = branchId;
        this.useOnlyMyOpinion = useOnlyMyOpinion;
        this.answers = answers;
        this.treatmentHistory = treatmentHistory;
        this.excludedRecommendations = excludedRecommendations
        this.comment = comment;
    }
}
